import { render, staticRenderFns } from "./merge-contacts-side-action.vue?vue&type=template&id=465217ea"
import script from "./merge-contacts-side-action.ts?vue&type=script&lang=js&external"
export * from "./merge-contacts-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports